import type { SessionSummary } from './api.js'

const FILLER_PREFIX = /^(stark[\s,]+|dis(?:-| )moi[\s,]+|peux(?:-| )tu[\s,]+|tu peux[\s,]+|j'ai[\s,]+|jai[\s,]+|hey[\s,]+|salut[\s,]+|bonjour[\s,]+|coucou[\s,]+)/i

/**
 * Sidebar / Récents label. Prefers the backend-generated `title`. Falls back
 * to a cleaned-up `first_user_message`: strips a leading vocative ("Stark, "),
 * trims trailing punctuation, capitalizes, and elides past 36 chars.
 */
export function cleanSessionTitle(s: SessionSummary): string {
  if (s.title && s.title.trim()) return s.title.trim()
  const raw = s.first_user_message ?? '(nouvelle session)'
  const stripped = raw.replace(FILLER_PREFIX, '').replace(/[?!.]+$/, '').trim()
  if (!stripped) return '(nouvelle session)'
  const capitalized = stripped.charAt(0).toUpperCase() + stripped.slice(1)
  if (capitalized.length <= 36) return capitalized
  return capitalized.slice(0, 35).trimEnd() + '…'
}
